export const CLIENT_TOKEN = 'iservice_client_app_token';
export const NOW_LOADING = 'NOW_LOADING';
export const END_LOADING = 'END_LOADING';
